module.exports = __webpack_public_path__ + "static/media/guitar.7d8edffa.svg";